module.exports = {
    Styler: require("./styler"),
    DataStyler: require("./datastyler"),
};
